import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { GiCrossedBones } from "react-icons/gi";
import { LuSave } from "react-icons/lu";
import { Trash2 } from "lucide-react";
import InsurerDropdown from "../../../../utils/Insurer";

const AddOtherInsuranceQuotation = () => {
    const [selectedYears, setSelectedYears] = useState(1);
    const navigate = useNavigate();


    const validationSchema = Yup.object({
        // Policy Info
        insurer: Yup.string().required("Insurer is required"),
        product: Yup.string().required("Product is required"),
        policyHolder: Yup.string().required("Policy holder is required"),
        quotationNo: Yup.string().required("Quotation number is required"),
        quotationDate: Yup.string().required("Quotation date is required"),

        // Coverage Info
        sumInsurer: Yup.string().required("Sum insured is required"),

        // Financial
        netPremium: Yup.string().required("Net premium is required"),
    });

    const handleSubmit = (formData, { resetForm }) => {
        console.log("Submitted:", formData);
        alert("Form Submitted!");
        resetForm();
    };

    return (
        <div className="formContainer lg:p-4 rounded" style={{ boxShadow: "0 0 8px #ccc" }}>
            <Formik
                initialValues={{
                    insurer: "",
                    product: "",
                    policyHolder: "",
                    quotationNo: "",
                    quotationDate: "",
                   
                    sumInsurer: "",
                    basicPremium: "",
                    addonPremium: "",
                    grossPremium: "",
                    gst: "",
                    netPremium: "",
                    notes: "",
                }}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >
                {({ values, isSubmitting }) => (
                    <Form className="p-4 bg-white rounded">
                        <h5 className="text-brandRed font-bold border-b border-brandRed pb-2 mb-4">Other Insurance Quotation</h5>

                        {/* Header Section */}
                        <div className="row g-3">
                            <div className="col-md-6">
                                <InsurerDropdown name="insurer" />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label">Product <span className="text-danger">*</span>
                                </label>
                                <Field as="select" name="product" className="form-select custom-shadow">
                                    <option value="">Select</option>
                                    <option value="Other Suraksha">Other Suraksha</option>
                                    <option value="MediCare">MediCare</option>
                                </Field>
                                <ErrorMessage name="product" component="div" className="text-danger" />
                            </div>
                            <div className="col-md-5">
                                <label className="form-label">Policy Holder <span className="text-danger">*</span>
                                </label>
                                <Field as="select" name="policyHolder" className="form-select custom-shadow">
                                    <option value="">Select</option>
                                    <option value="Rahul Sharma">Rahul Sharma</option>
                                    <option value="Priya Verma">Priya Verma</option>
                                </Field>
                                <ErrorMessage name="policyHolder" component="div" className="text-danger" />
                            </div>
                            <div className="col-md-1 mt-2 mt-md-5">
                                <button
                                    type="button"
                                    className="backButton"
                                    onClick={() => navigate("/customer-master/add")}
                                >
                                    Add
                                </button>
                            </div>
                            <div className="col-md-3">
                                <label className="form-label">Quotation No <span className="text-danger">*</span>
                                </label>
                                <Field name="quotationNo" className="form-control custom-shadow" />
                                <ErrorMessage name="quotationNo" component="div" className="text-danger" />
                            </div>
                            <div className="col-md-3">
                                <label className="form-label">Quotation Date <span className="text-danger">*</span>
                                </label>
                                <Field type="date" name="quotationDate" className="form-control custom-shadow" />
                                <ErrorMessage name="quotationDate" component="div" className="text-danger" />
                            </div>
                        </div>

                        {/* Product Information */}
                        <h6 className="text-secondary fw-bold mb-3 mt-4 bg-gray-100 rounded p-2">
                            Product Information</h6>
                        <div className="row g-3">                    
                            <div className="col-md-6">
                                <label className="form-label">Sum Insurerd <span className="text-danger">*</span>
                                </label>
                                <Field name="sumInsurer" className="form-control custom-shadow" />
                                <ErrorMessage name="sumInsurer" component="div" className="text-danger" />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label">No of Years</label>
                                <div className="d-flex gap-2">
                                    {[1, 2, 3].map((year) => (
                                        <button
                                            key={year}
                                            type="button"
                                            className={`toggle-btn ${selectedYears === year ? "active" : ""}`}
                                            onClick={() => setSelectedYears(year)}
                                        >
                                            {year}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* Premium Information */}
                        <h6 className="text-secondary fw-bold mb-3 mt-4 bg-gray-100 rounded p-2">
                            Premium Information</h6>
                        <div className="row g-3">
                            <div className="col-md-4">
                                <label className="form-label">Basic Premium</label>
                                <Field name="basicPremium" className="form-control custom-shadow" />
                            </div>
                            <div className="col-md-4">
                                <label className="form-label">Addon Premium</label>
                                <Field name="addonPremium" className="form-control custom-shadow" />
                            </div>
                            <div className="col-md-4">
                                <label className="form-label">Gross Premium</label>
                                <Field name="grossPremium" className="form-control custom-shadow" />
                            </div>
                            <div className="col-md-4">
                                <label className="form-label">GST</label>
                                <Field name="gst" className="form-control custom-shadow" />
                            </div>
                            <div className="col-md-4">
                                <label className="form-label">Net Premium <span className="text-danger">*</span>
                                </label>
                                <Field name="netPremium" className="form-control custom-shadow" />
                            </div>
                        </div>

                        {/* Notes */}
                        <div className="mb-4 mt-2">
                            <label className="form-label">Notes</label>
                            <Field as="textarea" name="notes" rows="4" className="form-control custom-shadow" />
                        </div>

                        {/* Buttons */}
                        <div className="d-flex justify-content-center gap-3 mt-5">
                            <button type="submit" className="saveButton d-flex" disabled={isSubmitting}>
                                <span className="m-auto p-1">
                                    <LuSave />
                                </span>
                                {isSubmitting ? "Saving..." : "Save"}
                            </button>
                            <button
                                type="button"
                                className="backButton d-flex align-items-center"
                                onClick={() => window.history.back()}
                            >
                                <span className="m-auto p-1">
                                    <GiCrossedBones />
                                </span>
                                Cancel
                            </button>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default AddOtherInsuranceQuotation;